import React, { useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-4";
import { useSnackbar } from "notistack";
import {
  Typography,
  Container,
  Stack,
  Tooltip,
  IconButton,
  Paper,
  Grid,
  Avatar,
  Fab,
  Button,
} from "@mui/material";
import { db } from "../firebase";
import { doc, setDoc, getDoc, Timestamp, updateDoc } from "firebase/firestore";
import { convertGoogleTimeStampsToDates } from "../helpers/convertGoogleTimeStampsToDates";
import { checkPhotoFile } from "../helpers/checkPhotoFile";
import { fileToBase64 } from "../helpers/fileToBase64";
// import { resizeImage } from "../helpers/resizeImage";
import { loadImage } from "../helpers/loadImage";
import { uploadToStorage } from "../helpers/uploadToStorage";
import { CameraAlt, Edit } from "@mui/icons-material";
import AccountEdit from "./AccountEdit";
import TAheader from "../images/header.png";
import TAfooter from "../images/footer.png";
import { onCheckout } from "../api/onCheckout";
import { onCustomerPortal } from "../api/onCustomerPortal";
import PlanType from "./PlanType";

var newUser = {
  created: Timestamp.now(),
  displayName: "",
  profilePicUrl: "",
  footerImageUrl: "",
  headerImageUrl: "",
  bio: "",
  email: "",
  storageUsed: 0,
  uid: "",
  stripeid: "",
  stripe_plan_type: "Free",
  stripe_price_id: "",
  stripe_customer: "",
  stripe_status: "",
};

export default function Account({ user, sendUpUserData }) {
  // const navigate = useNavigate();
  console.log("Profile page");
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [editingAccount, setIsEditingAccount] = React.useState(false);

  // const [isLoadingCheckUrl, setIsLoadingCheckUrl] = React.useState(false);

  // const [badProfileUrl, setBadProfileUrl] = React.useState(false);
  const [userData, setUserData] = React.useState(newUser);
  const [savedUserData, setSavedUserData] = React.useState(newUser);
  // const [selectedPic, setSelectedPic] = React.useState(-1);
  // const [verifyEmailOpen, setVerifyEmailOpen] = React.useState(false);
  // const [noEmailOpen, setNoEmailOpen] = React.useState(false);
  // const [newEmail, setNewEmail] = React.useState("");
  // const [validEmailInput, setValidEmailInput] = React.useState(false);
  // const [stripeOpen, setStripeOpen] = React.useState(false);
  // const [counties] = React.useState(stripeCounties);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // console.log("getting user");
        var docRef = null;
        var docSnap = null;
        // var stripeid = "";

        console.log(user);
        docRef = doc(db, "users", user.uid);
        docSnap = await getDoc(docRef);
        // console.log("got user");
        if (docSnap !== null && docSnap.exists()) {
          const userInfo = docSnap.data();
          // stripeid = userInfo.stripeid;
          setUserData(userInfo);
          sendUpUserData(userInfo);
          setSavedUserData(JSON.parse(JSON.stringify(userInfo)));
        } else {
          // eslint-disable-next-line no-throw-literal
          const displayName =
            window.location.href.split("?").length > 1
              ? window.location.href.split("?")[1]
              : user.displayName;
          // var displayNameUrl =
          //   window.location.href.split("?").length > 1
          //     ? window.location.href
          //         .split("?")[1]
          //         .replace(/[^a-zA-Z0-9-_]/g, "")
          //     : user.displayName.replace(/[^a-zA-Z0-9-_]/g, "");
          // const badUrl = await checkBadProfileUrl("0", displayNameUrl);
          // if (badUrl) {
          //   displayNameUrl = displayNameUrl + user.uid.substring(0, 6);
          // }
          // console.log("No such user");
          userData.email = user.email;
          userData.uid = user.uid;
          userData.displayName = displayName;
          userData.profilePicUrl = "";
          userData.footerImageUrl = "";
          userData.headerImageUrl = "";

          await saveUserData(userData);
          setUserData({ ...userData });
          setSavedUserData(JSON.parse(JSON.stringify(userData)));

          // if (user.photoURL !== null && user.photoURL.length > 0) {
          //   const base = await getBase64FromUrl(user.photoURL);
          //   const originalImg = await loadImage(base);
          //   const resized = resizeImage(originalImg);
          //   const url = await uploadToStorage(
          //     `users/${user.uid}/profilePicUrl.jpg`,
          //     resized
          //   );
          //   userData.profilePicUrl = url;
          // }
        }
      } catch (err) {
        enqueueSnackbar(err.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (user !== null && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  // const compressPhoto = async (file, resize = false) => {
  //   const arrayBuffer = await fileToBase64(file);
  //   const originalImg = await loadImage(arrayBuffer);
  //   return resize ? resizeImage(originalImg) : originalImg; // send it to canvas
  // };

  const saveUserData = async (userr) => {
    userr.updated = Timestamp.now();
    if (userr.created.hasOwnProperty("seconds")) {
      const dt = convertGoogleTimeStampsToDates(userr.created);
      userr.created = Timestamp.fromDate(dt);
    }
    await setDoc(doc(db, "users", userr.uid), userr, { merge: true });
    setSavedUserData(JSON.parse(JSON.stringify(userr)));
    sendUpUserData(userr);
  };

  // const handleChange = async (e) => {
  //   try {
  //     if (e.target.hasOwnProperty("name")) {
  //       userData[e.target.name] = e.target.value;
  //     } else {
  //       userData[e.target.id] = e.target.hasOwnProperty("checked")
  //         ? e.target.checked
  //         : e.target.value;
  //     }

  //     setUserData({ ...userData });
  //     if (e.target.id === "profileUrl") {
  //       //check for available link
  //       setIsLoadingCheckUrl(true);
  //       setBadProfileUrl(
  //         await checkBadProfileUrl(userData.uid, e.target.value)
  //       );
  //       setIsLoadingCheckUrl(false);
  //     }
  //   } catch (err) {
  //     enqueueSnackbar(err.message, {
  //       anchorOrigin: {
  //         vertical: "bottom",
  //         horizontal: "center",
  //       },
  //       variant: "error",
  //     });
  //   }
  // };

  // const handleSave = async () => {
  //   try {
  //     setIsLoading(true);
  //     await saveUserData(userData);
  //     enqueueSnackbar("Profile updated successfully.", {
  //       anchorOrigin: {
  //         vertical: "bottom",
  //         horizontal: "center",
  //       },
  //       variant: "success",
  //     });
  //   } catch (err) {
  //     enqueueSnackbar(err.message, {
  //       anchorOrigin: {
  //         vertical: "bottom",
  //         horizontal: "center",
  //       },
  //       variant: "error",
  //     });
  //   } finally {
  //     setIsLoading(false);
  //     setOpen(false);
  //   }
  // };

  const onEditClick = () => {
    setIsEditingAccount(!editingAccount);
  };

  const passUpProject = (user) => {
    setUserData({
      ...user,
    });
    setIsEditingAccount(false);
  };

  const onBuyClick = async (priceId) => {
    try {
      setIsLoading(true);
      const result = await onCheckout(
        user.uid,
        priceId, // priceid
      );
      if (
        result.hasOwnProperty("sessionUrl") &&
        result.hasOwnProperty("sessionId")
      ) {
        window.location.href = result.sessionUrl;
      } else {
        throw Error("Unable to create checkout session");
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onCustomerPortalClick = async () => {
    try {
      setIsLoading(true);
      const result = await onCustomerPortal(userData.stripe_customer);
      if (result.hasOwnProperty("sessionUrl")) {
        window.location.href = result.sessionUrl;
      } else {
        throw Error("Unable to create checkout session");
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onProfilePhotoChange = async (e) => {
    try {
      // setTextDialogOpen(false);

      setIsLoading(true);
      const file = e.target.files[0];
      const target = e.target.id;
      checkPhotoFile(file);

      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          throw new Error("File size exceeds 5MB limit.");
        } else if (target === "headerImageUrl") {
          const img = await loadImage(await fileToBase64(file));
          if (img.width !== 9408 || img.height !== 896) {
            throw new Error("Image dimensions must be 9408x896 pixels.");
          }
        } else if (target === "footerImageUrl") {
          const img = await loadImage(await fileToBase64(file));
          if (img.width !== 2260 || img.height !== 72) {
            throw new Error("Image dimensions must be 2260x72 pixels.");
          }
        }

        const resized = await fileToBase64(file);

        const fileName = target.substring(0, target.length - 3);
        const url = await uploadToStorage(
          `users/${userData.uid}/${fileName}.jpg`,
          resized,
        );

        userData[target] = url;
        await saveUserData(userData);
        setUserData({ ...userData });

        setSavedUserData(JSON.parse(JSON.stringify(userData)));

        // Reference to the specific document
        const docRef = doc(db, "users", user.uid);
        // Update only two properties
        var obj = {};
        obj[target] = url;
        await updateDoc(docRef, obj);

        enqueueSnackbar(`Picture updated.`, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading || savedUserData.uid.length === 0 ? null : (
    // <Backdrop
    //   sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    //   open={true}
    // >
    //   <CircularProgress color="inherit" />
    // </Backdrop>
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Container
        maxWidth="md"
        style={{
          paddingTop: 100,
          // paddingBottom: theme.spacing(4),
          justifyContent: "center",
        }}
      >
        <Paper elevation={6} style={{ marginBottom: 30, padding: 24 }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{ display: { xs: "none", sm: "flex" } }}
                style={{
                  width: 220,
                  height: 220,
                  // marginTop: -100,
                  // marginLeft: 50,
                }}
                alt=""
                src={savedUserData.profilePicUrl}
              />
              <Avatar
                sx={{ display: { xs: "flex", sm: "none" } }}
                style={{
                  width: 120,
                  height: 120,
                  marginTop: -70,
                  // marginLeft: 50,
                }}
                alt=""
                src={savedUserData.profilePicUrl}
              />
            </Stack>

            <Stack
              style={{ paddingBottom: 12 }}
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <label htmlFor="profilePicUrl">
                <input
                  style={{ display: "none" }}
                  id="profilePicUrl"
                  name="profilePicUrl"
                  type="file"
                  onChange={onProfilePhotoChange}
                />
                <Tooltip title={`Change Profile Picture`}>
                  <Fab
                    style={{
                      // position: "absolute",
                      zIndex: 99,
                      // top: 230,
                      // left: 220
                      // marginRight: 280
                    }}
                    color="primary"
                    size="small"
                    component="span"
                    aria-label="add"
                  >
                    <CameraAlt />
                  </Fab>
                </Tooltip>
              </label>
            </Stack>
          </Grid>

          <Typography style={{ textAlign: "center" }} variant="h5" gutterBottom>
            {`User name: ${userData.displayName}`}
          </Typography>
          <Typography
            style={{ textAlign: "center" }}
            variant="body1"
            gutterBottom
          >
            {`bio: ${userData.bio}`}
          </Typography>
          <Typography
            style={{ textAlign: "center" }}
            variant="body1"
            gutterBottom
          >
            {`email: ${userData.email}`}
          </Typography>
          <Stack
            style={{ paddingBottom: 12 }}
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <Tooltip title={`Edit Account Information`}>
              <IconButton
                onClick={onEditClick}
                aria-label={`Edit Account Information`}
                size="large"
                color="primary"
                // disabled={!allowUpdate}
              >
                <Edit fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Paper>

        <Paper elevation={6} style={{ marginBottom: 30, padding: 24 }}>
          <PlanType userData={userData} />
          <Stack
            direction={{ xs: "column", sm: "row" }}
            width="100%"
            spacing={2}
            sx={{
              paddingTop: 2,
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            {userData.stripe_status &&
            userData.stripe_status === "active" &&
            userData.stripe_plan_type === "Standard" ? (
              <Button variant="contained" onClick={onCustomerPortalClick}>
                Customer Portal
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => onBuyClick("price_1SxukEPYCUDMxm47OUjevyEg")}
              >
                {`${userData.stripe_plan_type === "Free" ? "Upgrade" : "Migrate"} to Standard`}
              </Button>
            )}

            {userData.stripe_status &&
            userData.stripe_status === "active" &&
            userData.stripe_plan_type === "Professional" ? (
              <Button variant="contained" onClick={onCustomerPortalClick}>
                Customer Portal
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => onBuyClick("price_1SxuktPYCUDMxm47krfCzUdV")}
              >
                Upgrade to Professional
              </Button>
            )}
          </Stack>
        </Paper>
        <Paper elevation={6} style={{ marginBottom: 30, padding: 24 }}>
          <Typography
            style={{ textAlign: "center" }}
            variant="body1"
            gutterBottom
          >
            {`Report Header Image`}
          </Typography>
          <Stack
            style={{ paddingBottom: 12 }}
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <label htmlFor="headerImageUrl">
              <input
                style={{ display: "none" }}
                id="headerImageUrl"
                name="headerImageUrl"
                type="file"
                onChange={onProfilePhotoChange}
              />
              <Tooltip title={`Change Header Image`}>
                <Fab
                  style={{
                    // position: "absolute",
                    zIndex: 99,
                    // top: 230,
                    // left: 220
                    // marginRight: 280
                  }}
                  color="primary"
                  size="small"
                  component="span"
                  aria-label="add"
                >
                  <CameraAlt />
                </Fab>
              </Tooltip>
            </label>
          </Stack>
          <img
            style={{ maxWidth: "100%" }}
            alt="headerImageUrl"
            src={
              !userData.hasOwnProperty("headerImageUrl")
                ? TAheader
                : userData.headerImageUrl.length === 0
                  ? TAheader
                  : userData.headerImageUrl
            }
          />

          <br />
          <br />
          <Typography
            style={{ textAlign: "center" }}
            variant="body1"
            gutterBottom
          >
            {`Report Footer Image`}
          </Typography>
          <Stack
            style={{ paddingBottom: 12 }}
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <label htmlFor="footerImageUrl">
              <input
                style={{ display: "none" }}
                id="footerImageUrl"
                name="footerImageUrl"
                type="file"
                onChange={onProfilePhotoChange}
              />
              <Tooltip title={`Change Footer Image`}>
                <Fab
                  style={{
                    // position: "absolute",
                    zIndex: 99,
                    // top: 230,
                    // left: 220
                    // marginRight: 280
                  }}
                  color="primary"
                  size="small"
                  component="span"
                  aria-label="add"
                >
                  <CameraAlt />
                </Fab>
              </Tooltip>
            </label>
          </Stack>
          <img
            style={{ maxWidth: "100%" }}
            alt="footerImageUrl"
            src={
              !userData.hasOwnProperty("footerImageUrl")
                ? TAfooter
                : userData.footerImageUrl.length === 0
                  ? TAfooter
                  : userData.footerImageUrl
            }
          />
        </Paper>

        {editingAccount && (
          <AccountEdit
            passUpProject={passUpProject}
            user={userData}
            onEditClick={onEditClick}
          />
        )}
      </Container>
    </Scrollbars>
  );
}
